import * as React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Image from 'mui-image';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';


import ImageGallery from "react-image-gallery";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    boxShadow: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  

function CatPanel(props) {
    const {cat_name, carousel_image_context, default_image, grid_size, children} = props;
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    console.log(carousel_image_context);
    let imgs = carousel_image_context.keys().map(carousel_image_context);
    let imageList = [];
    imgs.forEach(img => {
        imageList.push({'original': img});
    });
    console.log(imgs);
	return (
    <Grid size={grid_size}>
        <Typography variant='h5' sx={{mb:"1rem", textAlign: 'center' }}>{ cat_name }</Typography>
        <Box sx={{position:'relative'}}>
            <Image sx={{pb:"1rem", objectFit:'cover', display:'block'}} src={default_image} height={300} onClick={ handleOpen }/>
            <IconButton aria-label="close" size="large" onClick={handleOpen} sx={{position:'absolute', bottom:15, right:5}}>
                <OpenInFullIcon fontSize="inherit" />
            </IconButton>
        </Box>
        <Typography>
        { children }
        </Typography>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box sx={{ width: '100%', display:'flex', flexDirection:'column' }}>
                    <Box sx={{display:'flex', flexDirection:'row', justifyContent:'right', m:2}}>
                        <IconButton aria-label="close" size="large" onClick={handleClose}>
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <ImageGallery items={imageList} showPlayButton={false} showFullscreenButton={false}/>
                </Box>
            </Box>
        </Modal>
    </Grid>
    );
}

export default CatPanel;